import React, { useEffect, useMemo, useState } from 'react'
import { EditCartItemProps, SipValidationType, StpValidationType } from '../types'
import { Box, Checkbox, Grid, Skeleton, Typography, useTheme } from '@mui/material'
import { Formik, FormikValues, useFormik } from 'formik';
import { ReedemScheme, StpScheme, SwitchScheme } from './Scheme';
import { CheckIcon, UnCheckIcon } from '../../../assets/SvgIcons';
import { InvestmentFundType } from '../../../redux-store/types/api-types';
import { MandateCreation } from '../../../redux-store/types/investorProfile';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { CustomeBlueDropDown, CustomeModalButton, CustomeNumberInput, FormCheckBox } from '../../investorOverview/transcation/FromInput';

type Props = {
    data: EditCartItemProps
    currentTransactionType: string
    validation: StpValidationType
    scheme: InvestmentFundType
    bankDetails: MandateCreation[]
    schemeLoading: boolean
}

export default function Reedem(props: Props) {
    const { data, currentTransactionType, validation, scheme, bankDetails, schemeLoading } = props;
    const { onSave, redeemValue, onCancel, isLoading, investedValue, marketValue, balanceUnits, balanceAmount, switchValue, bankAccountNumber, transMode, freeUnits, nav } = data
    const { locale, currencyCode, currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);
    const entireBalanceCheck = data?.allUnitsFlag;


    const entireAmountValue = Math.round((!Number.isNaN(Number(nav ?? 0)) ? Number(nav ?? 0) : 0) * (freeUnits ?? 0))

    const { palette, typography } = useTheme()

    // sheme
    const schemeValidation = ReedemScheme({ validation, redeemValue, switchType: transMode, accountType: '', scheme, freeUnits: freeUnits ?? 0 })

    const filterValidation = scheme?.validations?.filter((item) => item?.transactionType === 'RED')?.[0]

    // handleSubmit
    function handleSubmitBtn(formValues: FormikValues) {
        onSave(
            data.id,
            currentTransactionType,
            {
                ...((formValues?.switchType || transMode) === "A" ? {
                    amount: !formValues.entireBalance ? formValues.redeemValue : (formValues?.switchType || transMode) === "A" ? entireAmountValue : freeUnits,
                    units: ''
                } : {
                    units: !formValues.entireBalance ? formValues.redeemValue?.toString() : (formValues?.switchType || transMode) === "A" ? Number(entireAmountValue).toString() : Number(freeUnits).toString(),
                    amount: ''
                }),
                transMode: formValues.switchType,
                bankAccountNumber: formValues.accountType,
                bankName: [...bankDetails]?.filter((item) => item?.bankAccountNumber === formValues.accountType)?.[0]?.bankName,
                allUnitsFlag: formValues.entireBalance ? 'Y' : 'N'
            }
        )
    }


    return (
        <Formik initialValues={{
            switchType: transMode,
            redeemValue: redeemValue || 0,
            accountType: bankAccountNumber,
            // entireBalance: marketValue === redeemValue
            entireBalance: (entireAmountValue == redeemValue) || (entireBalanceCheck === "Y" ? true : false)
        }} validationSchema={schemeValidation}
            onSubmit={handleSubmitBtn}
            enableReinitialize>
            {(formik) => {
                return (
                    <Box component={'form'} onSubmit={formik.handleSubmit}>
                        <Grid container>
                            <Grid item xs={4} sm={5} md={6} lg={6}>
                                <CustomeBlueDropDown
                                    isLoading={schemeLoading}
                                    disabled={isLoading}
                                    name={'switchType'}
                                    label={'Redeem Value'}
                                    list={[{ value: 'A', label: 'Amount' }, { value: 'U', label: 'Units' }]}
                                    boxStyle={{
                                        borderTopRightRadius: '0px',
                                        borderBottomRightRadius: '0px',
                                        borderRight: `1px solid ${palette.text.secondary}b2`
                                    }} onChange={(event, value) => {
                                        formik.setFieldValue('switchType', event.target.value);
                                        if (event.target.value === 'A') {
                                            formik.setFieldValue('entireBalance', false)
                                        }
                                    }} />

                                {formik.values.switchType === "U" && (
                                    <FormCheckBox name='entireBalance'
                                        isLoading={schemeLoading}
                                        disabled={isLoading}
                                        onChange={(event, value) => {
                                            formik.setFieldValue('entireBalance', value);
                                            if (value) {
                                                formik.setFieldValue('redeemValue', formik.values.switchType === "A" ? `${entireAmountValue}` : `${freeUnits}`)
                                            }
                                        }} />

                                    // <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px', marginTop: '0px', marginBottom: '10px', alignItems: 'center' }}>
                                    //     {schemeLoading && (
                                    //         <Skeleton variant="text" animation="wave" width={100} sx={{ marginTop: "10px" }} />
                                    //     )}
                                    //     {!schemeLoading && (
                                    //         <>
                                    //             <Checkbox
                                    //                 name='entireBalance'
                                    //                 checkedIcon={<CheckIcon />}
                                    //                 value={values.entireBalance}
                                    //                 defaultChecked={values.entireBalance}
                                    //                 onChange={handleCheckBox}
                                    //                 icon={<UnCheckIcon />}
                                    //                 sx={{ paddingLeft: "0px" }}
                                    //             />
                                    //             <Typography variant='body_500' color={palette.text.secondary}>Entire Balance</Typography>
                                    //         </>
                                    //     )}
                                    // </Box>
                                )}
                            </Grid>
                            <Grid item xs={8} sm={7} md={6} lg={6}>
                                <CustomeNumberInput
                                    name={'redeemValue'}
                                    disable={formik.values.entireBalance || isLoading}
                                    isLoading={schemeLoading}
                                    removeIcons={formik.values.switchType === "U"}
                                    minlabel={`${`${formik.values?.switchType || transMode}` === "A" ? `Min: ${(String.fromCharCode(parseInt(currencySymbol, 16)) + " " + (filterValidation?.minimumInstallmentAmount || 0))}` : `Max: ${(freeUnits || 0)}`}`}
                                    textType='number'
                                    boxStyle={{
                                        borderTopLeftRadius: '0px',
                                        borderBottomLeftRadius: '0px',
                                        marginTop: '3px',
                                    }}
                                    warningText={formik.values?.switchType === 'A' ? 'amount' : 'units'}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12} sx={{ paddingBottom: "20px" }}>
                                <CustomeBlueDropDown
                                    name={'accountType'}
                                    isLoading={schemeLoading}
                                    disabled={isLoading}
                                    label='Select Account'
                                    list={[...bankDetails]?.map((item: MandateCreation) => ({ value: item?.bankAccountNumber, label: `${item?.bankName}-${item?.bankAccountNumber}` }))}
                                />
                            </Grid>
                            <Grid
                                item
                                container
                                xs={12}
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderTop: `0.5px solid ${palette.text.secondary}B2`
                                }}
                            >
                                <Grid
                                    item
                                    container
                                    xs={10}
                                    sx={{
                                        columnGap: "35px",
                                        flexWrap: "nowrap",
                                        paddingTop: "30px",
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <CustomeModalButton
                                            // isLoading={isLoading || schemeLoading}
                                            type='button'
                                            disabled={isLoading || schemeLoading}
                                            onClick={() => onCancel()}
                                            variant='outlined'
                                            btnText='Cancel'
                                            boxStyle={{
                                                color: palette.text.primary,
                                            }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <CustomeModalButton
                                            type='submit'
                                            isLoading={isLoading}
                                            disabled={!formik.dirty || schemeLoading}
                                            variant='contained'
                                            btnText='Save Changes'
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>

                )
            }}
        </Formik>
    )
}